var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: This component needs a refactor to be more readable and maintainable
import { Box, VStack } from '@chakra-ui/react';
import { isSameDay } from 'date-fns';
import { useMemo } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { EventBase, Icon, Image } from '@/components';
import { CaptureService } from '@/services';
import { setCurrentUserPhaseEvent, useAuth } from '@/store';
import { APP_CONFIG, AuthActionType, DataTest, LightReportMetaValue, NativeAction, ROUTE, UrlParamsKey, UserPhaseEventMapping } from '@/types';
import { ResolveDate, emitNativeWebView, getObjListByKey } from '@/utils';
export var EventStateTypes;
(function (EventStateTypes) {
    EventStateTypes["ACTIVE"] = "active";
    EventStateTypes["COMPLETED"] = "completed";
    EventStateTypes["EXPIRED"] = "expired";
    EventStateTypes["LOCKED"] = "locked";
})(EventStateTypes || (EventStateTypes = {}));
const resolveDate = new ResolveDate();
export const EventListItem = (props) => {
    var _a, _b, _c;
    const navigate = useNavigate();
    const { completed, id, is_dependency_locked = undefined, meta: _meta, type, window_end, window_start } = props;
    const meta = getObjListByKey(_meta, 'key', 'value');
    const { dispatch } = useAuth();
    const event = useMemo(() => {
        const dateNow = new Date();
        const windowStart = new Date(window_start);
        const windowEnds = new Date(window_end);
        const isBeforeWindow = dateNow < windowStart;
        const isAfterWindow = dateNow > windowEnds;
        const isWithinWindow = !isBeforeWindow && !isAfterWindow;
        let status = EventStateTypes.ACTIVE;
        if (completed)
            status = EventStateTypes.COMPLETED;
        if (isBeforeWindow || is_dependency_locked)
            status = EventStateTypes.LOCKED;
        if (isAfterWindow)
            status = EventStateTypes.EXPIRED;
        return {
            dateNow,
            isAfterWindow,
            isBeforeWindow,
            isWithinWindow,
            status,
            windowEnds,
            windowStart
        };
    }, [props]);
    const eventUrl = event.status === EventStateTypes.ACTIVE
        ? type === UserPhaseEventMapping.LIGHT_REPORT
            ? generatePath((meta === null || meta === void 0 ? void 0 : meta.light_report_mode) === LightReportMetaValue.LIST
                ? ROUTE.LIGHT_REPORT_LIST
                : ROUTE.LIGHT_REPORT_DETAIL, { id })
            : `${generatePath(ROUTE.QUESTIONNAIRE, { id: (meta === null || meta === void 0 ? void 0 : meta.questionnaire_id) || id })}?${UrlParamsKey.EVENT_ID}=${id}`
        : '';
    const openEvent = () => {
        dispatch(setCurrentUserPhaseEvent(props));
        emitNativeWebView({
            payload: {
                path: eventUrl,
                title: meta === null || meta === void 0 ? void 0 : meta.name
            },
            type: NativeAction.LINK
        }, () => null);
        navigate(eventUrl);
    };
    const handleEventClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (event.status !== EventStateTypes.ACTIVE)
            return;
        const isQuestionnaire = type.toLocaleUpperCase() === APP_CONFIG.COMPONENTS.ScheduleEventType.QUESTIONNAIRE;
        if (!isQuestionnaire) {
            openEvent();
            return;
        }
        try {
            const status = yield CaptureService.eventSubmissionCheck({
                user_event_id: id
            });
            if (status === 204) {
                dispatch({
                    payload: { completedAt: new Date(), eventId: id },
                    type: AuthActionType.SET_COMPLETED_USER_PHASE_EVENTS
                });
                return;
            }
        }
        catch (error) {
            openEvent();
        }
    });
    const IconState = () => {
        switch (event.status) {
            case EventStateTypes.ACTIVE: {
                return _jsx(Icon, { name: 'chevron-right', type: 'solid' });
            }
            case EventStateTypes.COMPLETED: {
                return _jsx(Icon, { color: (meta === null || meta === void 0 ? void 0 : meta.text_colour) || 'green.60', name: 'check', type: 'solid' });
            }
            case EventStateTypes.LOCKED: {
                const { dateNow, isWithinWindow, windowStart } = event;
                const isEventSameDay = isSameDay(windowStart, dateNow);
                const formattedDate = resolveDate.formatDateLocalized(windowStart);
                const shouldShowTime = !(isWithinWindow && is_dependency_locked !== undefined);
                const displayTime = isEventSameDay ? formattedDate.time : formattedDate.date;
                return (_jsxs(VStack, Object.assign({ fontSize: 'xs', spacing: '0' }, { children: [_jsx(Icon, { m: 'auto', name: 'padlock', type: 'solid' }), shouldShowTime && _jsx(Box, { children: displayTime })] })));
            }
            default: {
                return null;
            }
        }
    };
    return (_jsx(EventBase, { bg: meta === null || meta === void 0 ? void 0 : meta.background_colour, className: event.status, color: meta === null || meta === void 0 ? void 0 : meta.text_colour, cursor: 'not-allowed', "data-test": DataTest.EVENT_LIST_ITEM, leftIcon: (meta === null || meta === void 0 ? void 0 : meta.icon_path) && _jsx(Image, { h: '24px', path: meta.icon_path }), onClick: handleEventClick, rightIcon: _jsx(IconState, {}), sx: {
            '&.active': {
                cursor: 'pointer'
            },
            '&.completed': {
                bg: 'grey.60',
                color: 'darkBrandBlue.70'
            },
            '&.expired': {
                display: 'none'
            },
            '&.locked': {
                bg: (_a = meta === null || meta === void 0 ? void 0 : meta.background_colour) !== null && _a !== void 0 ? _a : 'white.100',
                border: '2px solid',
                borderColor: (_b = meta === null || meta === void 0 ? void 0 : meta.background_colour) !== null && _b !== void 0 ? _b : 'grey.60',
                color: (_c = meta === null || meta === void 0 ? void 0 : meta.text_colour) !== null && _c !== void 0 ? _c : 'darkBrandBlue.70'
            }
        }, title: meta === null || meta === void 0 ? void 0 : meta.name }));
};
